module.exports = __webpack_public_path__ + "static/media/default.7c35f6c3.jpg";